module.exports = __webpack_public_path__ + "fonts/SFUIText-Heavy.cdec4716.woff2";